import { ContentColumnData } from "@/types/pages/blocks"

export default function ContentColumn(props: ContentColumnData) {
  const { description } = props

  return (
    <div className="relative w-full min-h-[360px] flex flex-col items-center justify-center group rounded-lg overflow-hidden bg-(--block-bg,var(--color-primary)) px-6 py-12">
      <div className="flex flex-col gap-4 md:gap-6 items-center max-w-3xl w-full">
        {description && (
          <div
            className="text-[color:var(--block-on-bg,var(--color-on-primary))] prose prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </div>
  )
}
